<div class="wheel" #wheel>
  @if (jackpotService.jackpot()?.status === 'rolling') {
  <svg
    class="arrow"
    width="33"
    height="71"
    viewBox="0 0 33 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0215 2.3094C14.4967 0.880339 17.5463 0.880339 20.0215 2.3094L28.0429 6.9406C30.5182 8.36966 32.0429 11.0107 32.0429 13.8688L32.0429 16.0831C32.043 16.8569 31.9307 17.6267 31.7096 18.3683L18.8965 61.3548C18.0448 64.2121 13.9982 64.2121 13.1465 61.3547L0.333351 18.3683C0.112297 17.6267 1.45091e-05 16.8569 1.30331e-05 16.0831L8.80968e-06 13.8688C3.35823e-06 11.0107 1.5248 8.36966 4.00001 6.94059L12.0215 2.3094Z"
      fill="#C4C4C4"
    />
    <mask
      id="mask0_890_14442"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="32"
      height="15"
    >
      <rect y="1" width="32" height="15" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_890_14442)">
      <path
        d="M12.0215 2.3094C14.4967 0.880339 17.5463 0.880339 20.0215 2.3094L28.0429 6.9406C30.5182 8.36966 32.0429 11.0107 32.0429 13.8688L32.0429 16.0831C32.043 16.8569 31.9307 17.6267 31.7096 18.3683L18.8965 61.3548C18.0448 64.2121 13.9982 64.2121 13.1465 61.3547L0.333351 18.3683C0.112297 17.6267 1.45091e-05 16.8569 1.30331e-05 16.0831L8.80968e-06 13.8688C3.35823e-06 11.0107 1.5248 8.36966 4.00001 6.94059L12.0215 2.3094Z"
        fill="url(#paint0_linear_890_14442)"
      />
    </g>
    <mask
      id="mask1_890_14442"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="16"
      height="67"
    >
      <rect y="1" width="16" height="67" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask1_890_14442)">
      <path
        d="M12.0215 2.3094C14.4967 0.880339 17.5463 0.880339 20.0215 2.3094L28.0429 6.9406C30.5182 8.36966 32.0429 11.0107 32.0429 13.8688L32.0429 16.0831C32.043 16.8569 31.9307 17.6267 31.7096 18.3683L18.8965 61.3548C18.0448 64.2121 13.9982 64.2121 13.1465 61.3547L0.333351 18.3683C0.112297 17.6267 1.45091e-05 16.8569 1.30331e-05 16.0831L8.80968e-06 13.8688C3.35823e-06 11.0107 1.5248 8.36966 4.00001 6.94059L12.0215 2.3094Z"
        fill="url(#paint1_linear_890_14442)"
      />
    </g>
    <path
      d="M14.5 9.86603C15.4282 9.33013 16.5718 9.33013 17.5 9.86603L20.5622 11.634C21.4904 12.1699 22.0622 13.1603 22.0622 14.2321V17.7679C22.0622 18.8397 21.4904 19.8301 20.5622 20.366L17.5 22.134C16.5718 22.6699 15.4282 22.6699 14.5 22.134L11.4378 20.366C10.5096 19.8301 9.93782 18.8397 9.93782 17.7679V14.2321C9.93782 13.1603 10.5096 12.1699 11.4378 11.634L14.5 9.86603Z"
      fill="white"
    />
    <path
      d="M16 13L18.5981 14.5V17.5L16 19L13.4019 17.5V14.5L16 13Z"
      fill="#FFAA00"
    />
    <path
      d="M12.0215 2.3094C14.4967 0.880339 17.5463 0.880339 20.0215 2.3094L28.0429 6.9406C30.5182 8.36966 32.0429 11.0107 32.0429 13.8688L32.0429 16.0831C32.043 16.8569 31.9307 17.6267 31.7096 18.3683L18.8965 61.3548C18.0448 64.2121 13.9982 64.2121 13.1465 61.3547L0.333351 18.3683C0.112297 17.6267 1.45091e-05 16.8569 1.30331e-05 16.0831L8.80968e-06 13.8688C3.35823e-06 11.0107 1.5248 8.36966 4.00001 6.94059L12.0215 2.3094Z"
      fill="url(#paint2_linear_890_14442)"
      fill-opacity="0.24"
    />
    <defs>
      <linearGradient
        id="paint0_linear_890_14442"
        x1="16.0215"
        y1="0"
        x2="16.0215"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="#A4A4A4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_890_14442"
        x1="16.0215"
        y1="0"
        x2="16.0215"
        y2="71"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_890_14442"
        x1="16.0215"
        y1="0"
        x2="16.0215"
        y2="71"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFAA00" stop-opacity="0" />
        <stop offset="1" stop-color="#FFAA00" />
      </linearGradient>
    </defs>
  </svg>
  }

  <circle-progress
    class="wheel-timer"
    [showTitle]="false"
    [showSubtitle]="false"
    [showUnits]="false"
    [percent]="(jackpotService.timer() / jackpotService.maxTimer()) * 100"
    [animationDuration]="100"
    [startFromZero]="false"
    [radius]="wheel.clientWidth / 2 - 2"
    [innerStrokeWidth]="2"
    [showInnerStroke]="true"
    [outerStrokeWidth]="2"
    [outerStrokeColor]="'var(--yellow)'"
    [innerStrokeColor]="'#232323'"
    [space]="0"
    [clockwise]="false"
    [backgroundPadding]="0"
    [renderOnClick]="false"
    [animation]="true"
  ></circle-progress>

  <div class="wheel-back"></div>
  <div class="wheel-back-2"></div>
  <div class="wheel-back-3"></div>
  <div class="wheel-target">
    <svg
      width="236"
      height="236"
      viewBox="0 0 236 236"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118 59.8702C121.818 59.8702 124.914 56.7746 124.914 52.9562V6.91428C124.914 3.09589 121.818 0.000244141 118 0.000244141C114.181 0.000244141 111.086 3.09589 111.086 6.91428V52.9562C111.086 56.7746 114.181 59.8702 118 59.8702ZM138.742 39.5412V25.3098C174.492 33.3052 202.695 61.5089 210.691 97.2586H196.459C189.023 69.1521 166.848 46.9779 138.742 39.5412ZM196.459 138.742H210.691C202.695 174.491 174.492 202.695 138.742 210.69V196.459C166.848 189.022 189.023 166.848 196.459 138.742ZM97.259 210.69V196.459C69.1525 189.022 46.9783 166.848 39.5415 138.742H25.3102C33.3055 174.491 61.5093 202.695 97.259 210.69ZM39.5415 97.2586H25.3102C33.3055 61.5089 61.5093 33.3052 97.259 25.3098V39.5412C69.1525 46.9779 46.9783 69.1521 39.5415 97.2586ZM118 176.13C114.181 176.13 111.086 179.226 111.086 183.044V229.086C111.086 232.904 114.181 236 118 236C121.818 236 124.914 232.904 124.914 229.086V183.044C124.914 179.226 121.818 176.13 118 176.13ZM52.9564 111.087C56.7748 111.087 59.8704 114.182 59.8704 118.001C59.8704 121.819 56.7748 124.915 52.9564 124.915H6.91452C3.09613 124.915 0.000488281 121.819 0.000488281 118.001C0.000488281 114.182 3.09613 111.087 6.91452 111.087H52.9564ZM229.086 124.915H183.044C179.226 124.915 176.13 121.819 176.13 118.001C176.13 114.182 179.226 111.087 183.044 111.087H229.086C232.904 111.087 236 114.182 236 118.001C236 121.819 232.904 124.915 229.086 124.915ZM142.274 117.999C142.274 104.592 131.405 93.7233 117.998 93.7233C104.591 93.7233 93.7218 104.592 93.7218 117.999C93.7218 131.407 104.591 142.275 117.998 142.275C131.405 142.275 142.274 131.407 142.274 117.999Z"
        fill="url(#paint0_linear_890_14428)"
        fill-opacity="0.05"
      />
      <defs>
        <linearGradient
          id="paint0_linear_890_14428"
          x1="118"
          y1="0.000244141"
          x2="118"
          y2="236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA900" />
          <stop offset="1" stop-color="#FEA900" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="round-info">
    <app-cost
      class="round-info__cost"
      [cost]="jackpotService.jackpot()?.value ?? 0"
      color="var(--yellow)"
      [balanceType]="'skins'"
    ></app-cost>
    <div class="round-info__skins">
      <svg-icon
        class="flex items-center justify-center s-24"
        src="assets/icons/shared/skins-quantity.svg"
        [svgStyle]="{
          width: '16px',
          height: '16px',
          path: {
            fill: 'var(--primary)'
          }
        }"
      />
      {{ jackpotService.allSkins().length }}/50
    </div>
    <button class="round-info__create" (click)="openJoinGame()">
      Join Game
    </button>
  </div>

  <svg xmlns="http://www.w3.org/2000/svg" class="main-wheel">
    <g class="users" #usersWheel>
      <g>
        <svg:circle
          r="40%"
          fill="none"
          stroke-width="10%"
          clip-path="url(#imageClip2)"
        ></svg:circle>
      </g>
      @for (bet of jackpotService.jackpot()?.bets; track $index; let i = $index)
      {
      <svg:g [attr.transform]="calculateBetRotate(i)">
        <circle
          r="40%"
          fill="none"
          stroke-width="10%"
          [attr.stroke]="bet.user_color"
          transform="rotate(-90)"
          [attr.stroke-dashoffset]="calculateStroke(40, bet.chances)"
        ></circle>
        @if (bet.chances > 5) {
        <svg:g
          [attr.transform]="
            imageLocation(bet.chances) + imageRotate(bet.chances)
          "
        >
          <image
            [attr.href]="bet.avatar"
            width="9%"
            height="9%"
            x="-4.5%"
            y="-4.5%"
            clip-path="url(#imageClip2)"
          />
        </svg:g>
        }
      </svg:g>
      }
    </g>
    <g class="shine" #shine>
      <circle
        r="42.5%"
        fill="none"
        stroke-width="5%"
        stroke="#FFFFFF30"
      ></circle>
    </g>
    <defs>
      <clipPath id="imageClip2">
        <circle r="4.5%" fill="none"></circle>
      </clipPath>
    </defs>
  </svg>
</div>
